"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.FONT = exports.AUDIO = exports.OTHER = exports.HEIC = exports.IMAGE = exports.VIDEO = void 0;
var VIDEO = "VIDEO";
exports.VIDEO = "VIDEO";
var IMAGE = "IMAGE";
exports.IMAGE = "IMAGE";
var HEIC = "HEIC";
exports.HEIC = "HEIC";
var OTHER = "OTHER";
exports.OTHER = "OTHER";
var AUDIO = "AUDIO";
exports.AUDIO = "AUDIO";
var FONT = "FONT";
exports.FONT = "FONT";